export const provinceDefaultValue = {
    id: '',
    name: '',
};
